package sarka.design.skoria.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import sarka.design.skoria.network.AuthRepository
import sarka.design.skoria.network.RegisterResult

data class RegisterUiState(
    val username: String = "",
    val email: String = "",
    val password: String = "",
    val confirmPassword: String = "",
    val isLoading: Boolean = false,
    val error: String? = null,
    val registrationSuccess: Boolean = false
)

class RegisterViewModel(
    private val authRepository: AuthRepository = AuthRepository()
) : ViewModel() {

    private val _state = MutableStateFlow(RegisterUiState())
    val state: StateFlow<RegisterUiState> = _state

    fun onUsernameChange(value: String) {
        _state.value = _state.value.copy(username = value, error = null)
    }

    fun onEmailChange(value: String) {
        _state.value = _state.value.copy(email = value, error = null)
    }

    fun onPasswordChange(value: String) {
        _state.value = _state.value.copy(password = value, error = null)
    }

    fun onConfirmPasswordChange(value: String) {
        _state.value = _state.value.copy(confirmPassword = value, error = null)
    }

    fun register() {
        val current = _state.value
        
        // Validation
        if (current.username.isBlank()) {
            _state.value = current.copy(error = "Username is required")
            return
        }
        if (current.username.length < 3) {
            _state.value = current.copy(error = "Username must be at least 3 characters")
            return
        }
        if (current.email.isBlank()) {
            _state.value = current.copy(error = "Email is required")
            return
        }
        if (!current.email.contains("@")) {
            _state.value = current.copy(error = "Invalid email address")
            return
        }
        if (current.password.isBlank()) {
            _state.value = current.copy(error = "Password is required")
            return
        }
        if (current.password.length < 6) {
            _state.value = current.copy(error = "Password must be at least 6 characters")
            return
        }
        if (current.password != current.confirmPassword) {
            _state.value = current.copy(error = "Passwords do not match")
            return
        }

        _state.value = current.copy(isLoading = true, error = null)

        viewModelScope.launch {
            val result = authRepository.register(current.username, current.email, current.password)
            _state.value = when (result) {
                is RegisterResult.Success -> _state.value.copy(
                    isLoading = false,
                    registrationSuccess = true
                )
                is RegisterResult.Error -> _state.value.copy(
                    isLoading = false,
                    error = result.message
                )
            }
        }
    }

}
